import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ew-split-payment-form',
  templateUrl: './split-payment-form.component.html',
  styleUrl: './split-payment-form.component.scss',
})
export class SplitPaymentFormComponent {
  constructor(
    private FB: FormBuilder,
    private TRANSLATE: TranslateService,
    private API: ApiService,
  ) {
    this.splitFormOutput = new EventEmitter<FormArray>();
    this.subscribeToFormChanges();
  }

  splitPayment = this.FB.group({
    splits: this.FB.array([this.splitForm]),
  });

  @Input() currencyAccountId: string | null = null;
  @Input() budget: number = 0;
  @Input() currency: string | null = null;

  @Output() splitFormOutput: EventEmitter<FormArray>;

  get splits() {
    return (this.splitPayment.controls['splits'] as FormArray)
      .controls as FormGroup[];
  }

  get totalAmount() {
    return Array.from(this.splits).reduce(
      (sum, control) => sum + control.value.amount,
      0,
    );
  }

  subscribeToFormChanges() {
    this.splitPayment.controls.splits.valueChanges.subscribe(() => {
      this.splitFormOutput.emit(this.splitPayment.controls.splits);
    });
  }

  getBeneficiaryLabel(index: number) {
    return this.TRANSLATE.instant('transactions:beneficiary') + ` #${index}`;
  }

  onInputValueChange(split: any) {
    split
      .get('amount')
      .setValue(
        split.value.type == 'percentage'
          ? (split.value.inputValue / 100) * this.budget
          : split.value.inputValue,
      );

    if (
      this.currencyAccountId &&
      split.value.bankAccount?.bankAccountId &&
      split.value.amount &&
      split.value.type
    ) {
      this.API.post(`/v1/payouts/get-rate/`, {
        currencyAccountId: this.currencyAccountId,
        bankAccountId: split.value.bankAccount?.bankAccountId,
        amount: split.value.amount,
      }).subscribe((response: any) => {
        split.get('rate').setValue(response.data);
      });
    }
  }

  addBeneficiary() {
    this.splitPayment.controls.splits.push(this.splitForm);
  }

  removeBeneficiary(index: number) {
    this.splitPayment.controls.splits.removeAt(index);
  }

  get splitForm() {
    return this.FB.group({
      bankAccount: [null, Validators.required],
      type: [null, Validators.required],
      inputValue: [null, Validators.required],
      amount: [0, Validators.required],
      reference: [null, Validators.required],
      rate: [null, Validators.required],
    });
  }
}
